import { AND, OR, MAYBE, MANY, MORE, JOIN, RECURSE, GROUP, TEXT, FAIL, LOG } from './stack-express'

//white space
let _ = /^\s*/

//basic primitives
let boolean = TEXT(/^(?:true|false)/, function (t) { return 'true' === t })
let nul = TEXT(/^null/, () => null)

//numbers, fairly complex
let non_zero_int = /^[1-9][0-9]+/
let int = /^-?(?:0|[1-9][0-9]*)/
let fraction = /^\.[0-9]+/
let decimal = AND(int, MAYBE(fraction))
let number = TEXT(AND(decimal, MAYBE(AND('e', /^[+-]?/, non_zero_int))), Number)
let opt = TEXT(/^[\+\-\*\/]/)
let compare = TEXT(/^(>=|<=|>|<|==|!=)/)

//strings, including escaped literals
function join(ary) {
  return ary.join('')
}
let escaped = AND('\\', TEXT(/^./)), unescaped = TEXT(/^[^"\n\\]+/)
let string = AND('"', GROUP(MANY(OR(escaped, unescaped)), join), OR('"', FAIL('expected "')))

//note, matching unescaped string using "repeated non quote" because
//it makes it much much faster than matching each individual character
//then passing it to join.

//objects and arrays.
let value = RECURSE()
let sp_value = AND(_, value, _)

let array = AND('[', _, GROUP(MAYBE(JOIN(OR(sp_value), ','))), _, OR(']', FAIL('expected ]')))

function getObject(ary, start) {
  let o = {}
  o[ary[0]] = ary[1]
  o.start = start
  return o
}

let sp_express = GROUP(MAYBE(JOIN(sp_value, OR(opt, compare))))
let funcName = AND(_, TEXT(/^[a-zA-Z_][a-zA-Z0-9_]*/), _)
let funcParams = AND('(', _, GROUP(MAYBE(JOIN(sp_express, ","))), _, ')')
let func = AND(funcName, funcParams)
let object = AND(_, GROUP(func, getObject), _)

value(OR(object, string, number, nul, boolean, array, opt))
let formula = OR(sp_value, FAIL('expected formula value'))

let resolution = (text, start) => {
  try {
    return formula(text, start)
  } catch (e) {
    return {error: e}
  }
}

let constantjs = (val) => {
  let base = OR(string, number, nul, boolean, array)
  if (val instanceof Array) {
    return AND('[', _, GROUP(MAYBE(JOIN(base, ","))), _, ']')('' + val, 0)
  }
  return base('' + val, 0)
}

let stringjs = (val) => {
  if (typeof val === "string") {
    return !opt(val, 0) && !compare(val, 0)
  }
  return false
}

let isSplitejs = (val) => {  
  return OR(opt, compare)('' + val, 0)
}

let isfunction = (formulaParam) => {
  return String(formulaParam).indexOf('[object Object]') >= 0
}

let isArray = (val) => {
  return OR(array)('' + val, 0)
}

let formatFormulaParam = (formulaParam, textOnly, inArray) => {
  if (!inArray) inArray = 0
  let content = ""
  if (!isfunction(formulaParam)) {
    if (isSplitejs(formulaParam)) {
      content += formulaParam
    } else {
      let val = (typeof formulaParam[0] === 'array' && formulaParam[0]) ? formulaParam[0] : formulaParam
      content += JSON.stringify(val)
    }
  } else {
    let key = Object.keys(formulaParam)[0]
    let name = /[0-9]+/.test(key) ? '' : key
    let values = JSON.parse(JSON.stringify(name === '' ? formulaParam : formulaParam[name]))

    if (name) {
      if (textOnly) {
        content += name
      } else {
        content += '<a class="paramformula" start="' +
          formulaParam.start + '" name = "' + name + '">' + name + '</a>'
      }
    }

    let params = ''
    values.forEach((param, index) => {
      let val = ""
      if (name) {
        val = formatFormulaParam(param, textOnly)
      } else {
        val = formatFormulaParam(param, textOnly, ++inArray)
      }
      let isOpt = isSplitejs(param)
      if (isfunction(param) && inArray === 1) {
        params += val
      } else {
        params += (index === 0 || isOpt) ? val : ',' + val
      }
      --inArray
    });

    if (name) {
      content += '(' + (/^\[{2}.+\]{2}$/.test(params)?params.substr(1, params.length - 2):params) + ')'
    } else if (inArray > 0) {
      content += '[' + params + ']'
      inArray--
    } else {
      content += params
    }
  }
  return content;
}

export const isExpress = (val) => {
  return OR(sp_express)('' + val, 0)
}

//获取数组的维度
const getDimCount = (arr) => {
	var list = [];
	var num = 0;
	for (var i = 0; i < arr.length; i++) {
		if (arr[i] instanceof Array) {
			for (var j = 0; j < arr[i].length; j++) {
				list.push(arr[i][j]);
			}
		}
	}
	if (list.length) {
		num = 1
		num += getDimCount(list)
	}
	return num;
}

const getParamFromStr = (str) => {
  let paramStr = []
  let pos = 0
  let isInStr = false
  let inArray = 0
  let inFunction = 0
  let lastPos = pos
  while (pos < str.length) {
    if (str.substr(pos, 1) === '"' && str.substr(pos - 1, 1) !== '\\') isInStr = !isInStr
    if (str.substr(pos, 1) === '[' && str.substr(pos - 1, 1) !== '\\') inArray++
    if (str.substr(pos, 1) === ']' && str.substr(pos - 1, 1) !== '\\') --inArray
    if (str.substr(pos, 1) === '(' && str.substr(pos - 1, 1) !== '\\') inFunction++
    if (str.substr(pos, 1) === ')' && str.substr(pos - 1, 1) !== '\\') --inFunction
    if (str.substr(pos, 1) === ',' && !isInStr && !inArray && inFunction < 2) {
      paramStr.push({
        start: lastPos,
        end: pos,
        str: str.substring(lastPos, pos)
      })
      lastPos = pos + 1
    }
    pos++
  }
  paramStr.push({
    start: lastPos,
    end: pos,
    str: str.substring(lastPos, pos)
  })
  
  let strFirst = paramStr[0].str
  let firstStart = strFirst.indexOf('(') + 1
  let firstEnd = paramStr[0].end
  paramStr[0] = {
    start: firstStart,
    end: firstEnd,
    str: str.substring(firstStart, firstEnd)
  }

  let strLast = paramStr[paramStr.length - 1].str
  let lastEnd = str.length - (strLast.length - strLast.lastIndexOf(')'))
  let lastStart = paramStr[paramStr.length - 1].start
  paramStr[paramStr.length - 1] = {
    end: lastEnd,
    start: lastStart,
    str: str.substring(lastStart, lastEnd)
  }

  return paramStr
}

let setFunction = (funcName, funcBody) => {
  parser.setFunction(funcName, new Function('return' + funcBody)())
}

export {
  resolution, constantjs, isArray, string, number, array, boolean, nul, stringjs, isSplitejs,
  formatFormulaParam, getDimCount, getParamFromStr, setFunction
}